import React from 'react'

import Authorization from '@shared/Authorization'
import Ticket from '@containers/Ticket'

import V2AccountLayout from '../V2AccountLayout'

// Atendimento dentro da conta V2 — o container V1 (iframe do Pipefy) reusado com
// a mesma Authorization open_case da rota /admin/atendimento.

export default function V2ContaAtendimento() {
  return (
    <V2AccountLayout>
      <div className="v2-acc-embed v2-acc-ticket">
        <h1 style={{ margin: '0 0 6px', fontFamily: 'Poppins,sans-serif', fontWeight: '600', fontSize: '30px', lineHeight: '1.1', letterSpacing: '-0.6px', color: '#373535' }}>
          Atendimento
        </h1>
        <p style={{ margin: '0 0 18px', fontSize: '14px', lineHeight: '1.5', color: '#6B6664' }}>
          Abra um chamado e nossa equipe responde pelo e-mail cadastrado.
        </p>
        <Authorization permissions={['open_case']}>
          <Ticket />
        </Authorization>
      </div>
    </V2AccountLayout>
  )
}
